export default "__VITE_ASSET__BlKFf7r$__"